import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';

const crm: AppRouteModule = {
  path: '/systemset',
  name: 'System',
  component: LAYOUT,
  redirect: '/systemset/index',
  meta: {
    icon: 'carbon:id-management',
    title: '系统配置',
    auth: 'systemset',
    orderNo: 60,
  },
  children: [
    {
      path: 'index',
      name: 'SystemIndex',
      component: () => import('/@/views/admin/system/index.vue'),
      meta: {
        title: '服务器配置',
        ignoreKeepAlive: false,
        auth: 'systemset.index',
      },
    },
  ],
};

export default crm;
